import React, { useEffect, useState } from "react";
import {
  Paper,
  Container,
  Typography,
  Box,
  Grid,
  Stack,
  Divider,
  IconButton,
  TextField,
  Hidden,
  Drawer,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import { Emoji } from "../components";
import { motion, AnimatePresence } from "framer-motion";

import { Controller, useForm } from "react-hook-form";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { format, parseISO } from "date-fns";
// Icones
import EditIcon from "@mui/icons-material/Edit";
import SupportIcon from "@mui/icons-material/Support";

import { useSelector, useDispatch } from "react-redux";
// Actions
import {
  cadastroMensagensGetMensagens,
  cadastroMensagensUpdMensagem,
} from "../redux/actions";
//
const fnGetText = (valor) => {
  switch (valor) {
    case "T": // Termos
      return "Termo aceite";
    default: // WhatsApp
      return "WhatsApp curriculo aceito";
  }
};
const CadastroMensagens = () => {
  const [intencaoAlterar, setIntencaoAlterar] = useState(null);
  // Chama um popup para editar a mensagem
  const dispatch = useDispatch();

  // Ler as mensagens
  useEffect(() => {
    dispatch(cadastroMensagensGetMensagens());
  }, [dispatch]);

  const { cadastroMensagens } = useSelector((state) => state);

  return (
    <Paper elevation={0}>
      <Drawer
        open={Boolean(intencaoAlterar)}
        onClose={() => setIntencaoAlterar(null)}
        anchor="bottom"
      >
        <FormularioEditar itens={cadastroMensagens} id={intencaoAlterar} />
      </Drawer>
      <Container maxWidth="lg">
        <Typography align="center" variant="h6">
          Mensagens do aplicativo
        </Typography>
        {cadastroMensagens && (
          <ListaDeMensagens
            fnAlterar={setIntencaoAlterar}
            itens={cadastroMensagens}
          />
        )}
      </Container>
    </Paper>
  );
};
// Componente aba
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Componente que exibe um formulario para edicao
const FormularioEditar = ({ itens, id }) => {
  //
  const [exibirAjuda, setExibirAjuda] = useState(false);
  const [abaSelecionada, setAbaSelecionada] = useState(0);

  const dispatch = useDispatch();

  //
  const {
    watch,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // Pega a mensagem do campo selecionado
  const ITEM = itens.filter((ele) => String(ele.id) === String(id));
  if (ITEM.length === 0) {
    return null;
  }
  const { tipo, mensagem } = ITEM[0];
  // Funcao de callback para manipular o campo de texto
  const fnAlterarTexto = (valor) => {
    let msg = watch("mensagem");
    setValue("mensagem", `${msg}${valor}`);
  };
  // Funcao de callback para manipular o formulario
  const fn = (val) => {
    console.log(val);
    dispatch(cadastroMensagensUpdMensagem({ mensagem: val.mensagem, id: id }));
  };

  return (
    <Container sx={{ p: 1, height: "85vh" }} maxWidth="lg">
      <Tabs
        value={abaSelecionada}
        onChange={(evt, valor) => setAbaSelecionada(valor)}
      >
        <Tab label="Formulario" {...a11yProps(0)} />
        <Tab label="Visualizar" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={abaSelecionada} index={0}>
        <>
          <Typography variant="subtitle2" align="center">
            ALTERAÇÃO DA MENSAGEM
          </Typography>
          <Typography component="p" variant="caption" align="center">
            Edite a mensagem do {fnGetText(tipo)}
          </Typography>
          <Grid sx={{ mt: 0.5 }} container spacing={2}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="mensagem"
                defaultValue={mensagem}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    label="Mensagem"
                    {...field}
                    placeholder="Digite a mensagem"
                    multiline
                    minRows={5}
                    fullWidth
                    error={!!errors.mensagem}
                    helperText={!!errors.mensagem && "Campo obrigatório"}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Emoji onClick={fnAlterarTexto} />
                <Button
                  onClick={() => setExibirAjuda((state) => !state)}
                  startIcon={<SupportIcon />}
                >
                  AJUDA
                </Button>
              </Stack>
              <AnimatePresence>
                {exibirAjuda && (
                  <motion.div
                    key="ajuda"
                    transition={{ duration: 0.5 }}
                    initial={{ height: 0 }}
                    animate={{ height: "auto" }}
                    exit={{ height: 0 }}
                  >
                    <AjudaFormatacao />
                  </motion.div>
                )}
              </AnimatePresence>
            </Grid>
            <Hidden mdDown>
              <Grid item md={4} />
            </Hidden>
            <Grid item xs={12} md={4}>
              <Button fullWidth variant="contained" onClick={handleSubmit(fn)}>
                ENVIAR
              </Button>
            </Grid>
          </Grid>
        </>
      </TabPanel>
      <TabPanel value={abaSelecionada} index={1}>
        <Mensagem tipo={tipo} mensagem={watch("mensagem")} />
      </TabPanel>
    </Container>
  );
};
// Componente para exibir as imagens
const ListaDeMensagens = ({ fnAlterar, itens }) => {
  return (
    <Grid container spacing={1}>
      {itens.map((ele, idx) => {
        const { id, data, mensagem, tipo, usuario } = ele;

        return (
          <Grid key={idx} item xs={12} md={6}>
            <Paper sx={{ minHeight: "60vh", p: 1 }} elevation={2}>
              <Stack spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography sx={{ flex: 1 }} variant="subtitle1">
                    TIPO: {fnGetText(tipo)}
                  </Typography>
                  <IconButton onClick={() => fnAlterar(id)} color="primary">
                    <EditIcon />
                  </IconButton>
                </Stack>
                <Typography variant="caption">
                  ALTERADO EM: {format(parseISO(data), "dd/MM/yy HH:mm:ss")}
                </Typography>
                <Typography variant="caption">CRIADO POR: {usuario}</Typography>
                <Divider />
                <Mensagem tipo={tipo} mensagem={mensagem} />
              </Stack>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};
// Renderiza componente responsavel por exibir a mensagem
const Mensagem = ({ tipo, mensagem }) => {
  switch (tipo) {
    case "T": // Termos, este usa Markdown
      return <ReactMarkdown children={mensagem} remarkPlugins={[remarkGfm]} />;
    default: // Mensagem WhatsApp
      return <Typography variant="body2">{mensagem}</Typography>;
  }
};
// Componente que exibe uma lista com textos mostrando como formatar o texto
const AjudaFormatacao = () => {
  return (
    <Paper elevation={2} sx={{ p: 1 }}>
      <Stack>
        <Typography variant="h6">Formatação de Texto</Typography>
        <Typography variant="boby2">
          Esta ferramenta faz uso do Markdown para formatação de texto. Alguns
          caracteres tem significado aqui. Estarei listando alguns
        </Typography>
        <Divider />
        <Typography variant="subtitle1">Titulos</Typography>
        <Typography variant="caption"># (Representa titulo)</Typography>
        <Typography variant="caption">## (Subtitulo titulo)</Typography>
        <Typography variant="caption">### (Abaixo do subtitulo)</Typography>
        <Divider />
        <Typography variant="subtitle2">Para um sublinhado</Typography>
        <Typography variant="caption">
          ---- (4 ou mais traços para criar um divisor)
        </Typography>
        <Divider />
        <Typography variant="subtitle2">Negrito e italico</Typography>
        <Typography variant="body2">**este** texto esta em negrito</Typography>
        <Typography variant="body2">*este* texto esta em itálico</Typography>
        <Divider />
        <Typography variant="subtitle2">Compondo listas</Typography>
        <Typography variant="body2">
          Listas são criadas com - no começo da linha e um espaço separando a
          palavra
        </Typography>
        <Typography variant="body2">- Um</Typography>
        <Typography variant="body2">- Dois</Typography>
        <Typography variant="body2">- Tres</Typography>
        <Divider />
        <Typography variant="subtitle2">Representando links</Typography>
        <Typography variant="body2">
          Ja os links sao protegidos por parentese com o nome do link entre
          chaves
        </Typography>
        <Typography variant="body2">
          [clique aqui](https://www.google.com.br)
        </Typography>
        <Divider />
        <Typography variant="subtitle2">
          Representando imagens (Por URL)
        </Typography>
        <Typography variant="body2">
          As imagens (URL para imagens) sao protegidos por parentese com o nome
          do link entre chaves precedido por ! (exclamação)
        </Typography>
        <Typography variant="body2">
          ![clique aqui](https://www.google.com.br)
        </Typography>
      </Stack>
    </Paper>
  );
};

export default CadastroMensagens;
